import styled from 'styled-components'
import {spacing} from '../../../../../theme/spacing'

export const TimePeriodContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${spacing(4)};
`
export const Label = styled.label`
    font-size: 14px;
    margin-bottom: 0;
`
export const Input = styled.div`
    display: flex;
    flex-direction: column;
    width: 150px;
`
export const Select = styled.select`
    text-align-last: center;
    padding: 3px ${spacing(3)};
    font-weight: ${(props) => props.theme.font.weight.extrabold};
    font-size: 12px;
    border: 1px solid ${(props) => props.theme.colors.border.lowContrast};
    border-radius: 3px;
`
